<template>
    <div class="animated fadeIn">


        <div class="mb-2">
            <b-dropdown text="Options">
                <b-dropdown-item @click="preview">
                    <span>{{Core.Definition.getDefinition('Aperçu')}}</span>
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <ModalFormTemplatePreview ref="modalFormTemplatePreview"></ModalFormTemplatePreview>

        <b-tabs>
            <b-tab :active="true" v-if="Core.Validation.isId(dataId)">
                <template slot="title">
                    <i class="fa fa-list mr-2"></i>{{Core.Definition.getDefinition('Structure')}}
                </template>
                <FormTemplateStructure v-model="dataId"></FormTemplateStructure>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-cogs mr-2"></i>{{Core.Definition.getDefinition('Paramètres')}}
                </template>
                <DynamicForm
                        v-model="dataId"
                        ref="dynamicForm"
                        getRoot="/form-template"
                        saveRoot="/form-template"
                        @onSave="onSave"
                        :formStructure="dataFormStructures.form">
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import FormTemplateStructure from './FormTemplateStructure'
    import ModalFormTemplatePreview from '../../components/ModalFormTemplatePreview'

    export default {
        name: 'FormTemplate',
        components: {
            DynamicForm,
            FormTemplateStructure,
            ModalFormTemplatePreview
        },
        mounted() {

        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataId: '',
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'description'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'city'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'template'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'template',
                                type: 'text',
                                label: Core.Definition.getDefinition('Modèle'),
                                value: ''
                            },
                            {
                                id: 'city',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Ville'),
                                value: null,
                                onSelect: this.onSelect,
                                options: [
                                    {
                                        label: 'Montréal',
                                        value: 'montreal'
                                    },
                                    {
                                        label: 'Québec',
                                        value: 'quebec'
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            preview() {
                this.$refs.modalFormTemplatePreview.open(this.dataId, '')
            },
            onSave() {
                this.$refs.dynamicForm.addSaveArg('instance', Mantle.FormTemplate.instanceForm)
            },
            onSelect() {

            }
        }
    }
</script>
